module.exports = __webpack_public_path__ + "static/img/9areaB_09.0ab6d75.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_09.png
// module id = 1250
// module chunks = 1